import React, { Component } from 'react';

import '../css/About.css';

class About extends Component {
  render() {
    return (
      <div className="container-fluid">
        <h1>About</h1>
        <br />
        <hr />
        <div className="content">
          <p>Market Hub is a comprehensive financial data platform that provides real-time market information and analysis tools for both stocks and cryptocurrencies. This application offers:</p>
          <p>- Real-time stock market data with interactive charts and candlestick patterns</p>
          <p>- Cryptocurrency tracking and analysis with detailed market metrics</p>
          <p>- Latest financial news and market updates</p>
          <p>- User authentication for personalized experience</p>
          <p>The platform integrates with reliable financial data providers including Polygon.io and Finnhub to deliver accurate and up-to-date market information. Built with React and modern web technologies, Market Hub provides a responsive and intuitive interface for tracking your investments and staying informed about market movements.</p>
        </div>
        <hr />
        <p>
            Repo:{' '}
            <a
              href="https://github.com/ovimura/marketupdates"
              className="aAbout"
            >
              marketupdates
            </a>
        </p>
          <hr />
      </div>
    );
  }
}

export default About;
